import { StudyRoles, User } from '../../../models/Auth'

export const isStudyRepresentative = (user: User) => {
  return user.StudyRoles.includes(StudyRoles.StudyRepresentative)
}

export default isStudyRepresentative
